export { C as City, F as FEMALE, H as HasCountableForm, a as HasGender, L as Localization, M as MALE, N as Name, P as Partner, T as TrustedValue, U as UNSPECIFIED, L as default } from './localization-7efa87df.js';
import 'html-entities/lib/xml-entities';
import './counted-form/index.js';
